import {useState} from "react"
import {useNavigate} from "react-router-dom"
import {useSelector, useDispatch} from "react-redux"
import {thunks as userThunks} from "../global/slices/usersSlice"
import Spinner from 'react-bootstrap/Spinner';
import Container from "react-bootstrap/esm/Container"

export default function Login() {
  const dispatch = useDispatch()
  const nav = useNavigate()
  const {isLoading} = useSelector(state => state.users)

  const [form, setForm] = useState({username: "", password: ""})

  const onFormChange = (e) => {
    setForm({...form, [e.target.name]: e.target.value})
  }

  const submit = (e) => {
    e.preventDefault()
    dispatch(userThunks.login(form)).unwrap().then(() => nav("/members"))
  }

  if (isLoading) return (
    <div id="overlay">
      <p className="my-3 fs-3 fw-bolder">Logging In</p>
      <Spinner animation="border" variant="success" role="status"></Spinner>
    </div>
  )

  return (
    <Container>
      <div className="row text-white pt-5">
        <div className="col-12 col-lg-6 mx-auto">
          <form onSubmit={submit} className="mx-auto">
            <h2 className="mb-4 text-center">Login</h2>
            <div className="row gy-4">
              <div className="col-12">
                <label className="form-label">Username</label>
                <input
                  onChange={onFormChange}
                  value={form.username}
                  name="username"
                  type="text"
                  className="form-control"
                  placeholder="awair-element_xxxxx"
                />
              </div>
              <div className="col-12">
                <label className="form-label">Password</label>
                <input
                  onChange={onFormChange}
                  value={form.password}
                  name="password"
                  type="password"
                  className="form-control"
                  placeholder="**********"
                />
              </div>
            </div>
            <button disabled={isLoading} type="submit" className="w-100 btn btn-success mt-5">
              Login
            </button>
          </form>

          <br/>

          <p>
            <a href="/changepw" className="reset-pass-link">I forgot my password</a>
          </p>
        </div>
      </div>
    </Container>
  )
}
